import Timer from "../gd/task-timer/timer";
import Task from "../model2/task/task";
import ModalCreateTimeReport from "./time-report/create/modal-create-time-report";

export type TimeReportForTaskOptions = {
    date?                   : Moment,
    callback?               : callback,
    needMyTimeResponse?     : boolean,
    userId?                 : ID,
    taskMessageId?              : ID    // add time report for message

}

export default class MyTimeModalsManager {

    constructor() {}

    timeReportForTask(task : Task, options:TimeReportForTaskOptions = {}) {

        // userId -> viewFor user id in my work
        // report time on behalf of someone else (!)

        gd.modal.showV4({
            className   : 'modal-time-report',
            component   : ModalCreateTimeReport,

            params      : {
                task                : task,
                date                : options.date,
                callback            : options.callback,
                needMyTimeResponse  : options.needMyTimeResponse,
                userId              : options.userId,
                taskMessageId       : options.taskMessageId
            }
        });
    }

    submitTimer(timer:Timer, minDate:Moment, callback:callback) {

        gd.modal.showV4({
            className   : 'modal-time-report',
            component   : ModalCreateTimeReport,

            params: {
                timer           : timer,
                task            : timer.task,
                minDate         : minDate,
                // date            : date,
                callback        : callback,

                reportedTimeMinutes : timer.timeInMinutes,
                startMoment         : timer.startEnd.start,
                endMoment           : timer.startEnd.end,
            }
        });
    }




}

// module.exports = MyTimeModalsManager;